module.exports = __webpack_public_path__ + "static/notifications3-e28175c5a02b6f57a9228d114ba9cfca.png";